import { matchPath, useLocation } from 'react-router-dom';

import { useIsConservation } from '@/hooks/useIsConservation';
import { useScreenSize } from '@/hooks/useScreenSize';
import { paths } from '@/routing/routing';

export const useDisplayCoPilot = (): boolean => {
  const isSmallScreen = useScreenSize() === 'small';
  const { pathname } = useLocation();
  const isConservation = useIsConservation();

  if (isConservation) {
    return false;
  }

  if (isSmallScreen) {
    return false;
  }

  return !PAGES_WITHOUT_CO_PILOT.find((path) => matchPath(path, pathname));
};
export const PAGES_WITHOUT_CO_PILOT = [
  // Public pages
  paths.activateAccount,
  paths.confirmMailChange,
  paths.login,
  paths.loginImpersonate,
  paths.newPassword,
  paths.resetPassword,
  paths.invalidUrl,
  paths.root,

  // Land Steward
  paths.landSteward.account,
  paths.landSteward.accountEditEmail,
  paths.landSteward.accountEditName,
  paths.landSteward.accountEditPassword,
  paths.landSteward.accountLegal,
  paths.landSteward.accountTeam,
  paths.landSteward.accountTeamEditMember,
  paths.landSteward.accountTeamInvite,
  paths.landSteward.copilot,
  paths.landSteward.restrictedAccess,

  // Buyer
  paths.buyer.account,
  paths.buyer.accountEditEmail,
  paths.buyer.accountEditName,
  paths.buyer.accountEditPassword,
  paths.buyer.accountLegal,
  paths.buyer.accountTeam,
  paths.buyer.accountTeamEditMember,
  paths.buyer.accountTeamInvite,
  paths.buyer.copilot,
  paths.buyer.restrictedAccess,

  // staff
  paths.staff.copilot,
];
